import React from 'react';
import { Container } from './styled';

export default function Page() {
	return (
		<Container>
			Desenvolvido por Lucas Santos
			<br/>
			Dados usados de developers.mercadolivre.com.br 
		</Container>
	)
}

